module.exports = __webpack_public_path__ + "img/category.c312cc96.png";